import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const HostPropertiesHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold">My Properties</h1>
        <p className="text-muted-foreground">
          Manage and update your property listings
        </p>
      </div>
      <Button onClick={() => navigate("/host/properties/add")}>
        <Plus className="h-4 w-4 mr-2" />
        Add Property
      </Button>
    </div>
  );
};